import { FileMinus02, UsersMinus } from "@untitledui/icons";
import { useRemoveFromCreatorList } from "@/api/creator-lists";
import { Button } from "@/components/base/buttons/button";
import { ButtonUtility } from "@/components/base/buttons/button-utility";
import { success } from "@/providers/ToastProvider";
import { pluralize } from "@/utils/text";

export const RemoveFromCreatorList = ({
  selected,
  list,
  onRemove,
}: {
  selected: string[];
  list: string;
  onRemove: () => void;
}) => {
  const { mutateAsync, isPending } = useRemoveFromCreatorList();

  const remove = async () => {
    try {
      await mutateAsync({
        id: list,
        creators: selected,
      });
      success(`${pluralize(selected.length, "creator", "creators")} removed from this list`);
      onRemove();
    } catch {}
  };
  return (
    <Button isDisabled={isPending} onClick={remove} iconLeading={FileMinus02}>
      Remove from list
    </Button>
  );
};

export const RemoveFromCreatorListUtility = ({
  selected,
  list,
  onRemove,
}: {
  selected: string[];
  list: string;
  onRemove: () => void;
}) => {
  const { mutateAsync, isPending } = useRemoveFromCreatorList();

  const remove = async () => {
    try {
      await mutateAsync({
        id: list,
        creators: selected,
      });
      success(`${pluralize(selected.length, "creator", "creators")} removed from this list`);
      onRemove();
    } catch {}
  };
  return (
    <ButtonUtility
      size="xs"
      isDisabled={isPending}
      color="tertiary"
      tooltip="Remove from list"
      onClick={remove}
      icon={UsersMinus}
    ></ButtonUtility>
  );
};
